import Keycloak from 'keycloak-js';
import {keycloakConfig} from '../config/settings';

const keycloak = new Keycloak(keycloakConfig);

export {keycloak};
